export function delay(duration: number): Promise<void> {
	return new Promise(resolve => {
		setTimeout(() => {
			resolve();
		}, duration);
	});
}

export async function resolveWithDelay<T>(promise: Promise<T>, timeout: number): Promise<T> {
	return new Promise((resolve, reject) => {
		const delayPromise = delay(timeout);
		promise.then(
			result => delayPromise.then(() => resolve(result)),
			reason => delayPromise.then(() => reject(reason)),
		);
	});
}

export async function resolveWithSmallDelay<T>(promise: Promise<T>): Promise<T> {
	return resolveWithDelay(promise, 500);
}
